@let k = kitchen();
<a
  (click)="onCardSelected.emit()"
  [queryParams]="variantFrontSelected() ? { filter_front: variantFrontSelected() } : {}"
  [routerLink]="k.url"
  class="group relative block cursor-pointer">
  <div #visual class="z-0 h-[480px] overflow-hidden rounded-3xl desk:h-[464px]">
    @if (imageSelected()) {
      <app-image [hoverEffect]="true" [image]="imageSelected()!" />
    }
  </div>
  <div class="relative z-10 mx-auto -mt-11 w-[350px] rounded-2xl bg-gray-light p-4 desk:w-[440px]">
    <div class="flex items-baseline justify-between pb-2">
      <span
        [class]="kitchenNameLength() >= 0 ? 'text-[25px] leading-[27px]' : 'text-[35px] leading-[38px]'"
        class="font-title desk:text-[35px]">
        {{ k.name }}
      </span>
      <div
        (click)="openPriceDetailsDialog(); $event.stopPropagation(); $event.preventDefault()"
        class="text-nowrap font-title text-[30px] desk:text-[35px]">
        {{ k.price }}
      </div>
    </div>
    <div class="flex justify-between pb-2 desk:pb-4">
      <span class="flex items-center gap-x-1.5 text-[10px]">
        {{ "COMPONENT.KITCHEN-MODEL-CARD.SEE_THIS_KITCHEN" | translate }}
        <app-svg [width]="12" src="assets/icons/arrow-right.svg" />
      </span>
      <div
        (click)="openPriceDetailsDialog(); $event.stopPropagation(); $event.preventDefault()"
        class="text-end text-[10px]">
        @if (k.ecoPart) {
          {{ "GLOBAL.INCLUDING_ECO_PART" | translate: { price: k.ecoPart } }}
        }
        <span class="inline-flex size-[15px] cursor-pointer items-center justify-center rounded border font-title">
          ?
        </span>
      </div>
    </div>
    @if (kitchenVariants(); as kitchenVariants) {
      <div class="grid grid-cols-6">
        @for (variant of kitchenVariants.slice(0, 6); track variant.id) {
          <span
            (click)="onVariantSelect(variant.id); $event.stopPropagation(); $event.preventDefault()"
            (pointerenter)="onImageHover(variant.id)"
            class="flex flex-col items-center gap-2.5">
            <div
              [ngClass]="{ 'outline outline-offset-2 outline-2 outline-black': variantIdSelected() === variant.id }"
              class="relative size-[30px] overflow-hidden rounded-[10px] border border-black/25 desk:size-[35px]">
              @if (variant.colorPreview; as colorPreview) {
                <app-image
                  [image]="colorPreview"
                  [title]="variant.name"
                  class="block size-full rounded-[10px] object-cover">
                </app-image>
              } @else {
                <div [style.backgroundColor]="`rgb(${variant.colorRgb})`" class="size-full"></div>
              }
            </div>
            <span [title]="variant.shortName" class="line-clamp-2 text-center text-[10px] leading-none">
              {{ variant.shortName }}
            </span>
          </span>
        }
      </div>
    }
  </div>
</a>
